<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="110px">
        <div class="filter-col">
          <el-form-item label="证件号码：">
            <el-input clearable v-model="filterForm.idCard" placeholder="请输入证件号码"></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="单位名称：">
            <el-input clearable v-model="filterForm.o_name" placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.contract.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
        </div>
        <!-- <div class="filter-col">
          <el-form-item label="用工起始时间：">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="用工截止时间：">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
        </div> -->
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>

        <!-- <el-table-column label="文件" width="362" align="center">
          <template slot-scope="scope">

            <template v-if="Array.isArray(scope.row.fileNameAndId)">
              <p v-for="(x,i) in scope.row.fileNameAndId" :key="i" class="file-item">
                <span class="file-name">{{x.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

            <template v-else-if="scope.row.fileNameAndId">
              <p class="file-item">
                <span class="file-name">{{scope.row.fileNameAndId.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+scope.row.fileNameAndId.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="scope.row.fileNameAndId.fileName" :href="puUrl_x+'/'+scope.row.fileNameAndId.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

          </template>
        </el-table-column> -->

        <!-- <el-table-column label="支付凭证" width="121" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px" :src="scope.row.transferUrl|toimg" fit="fill"
              :preview-src-list="[scope.row.transferUrl]|toimgs" v-if="scope.row.transferUrl"></el-image>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="signContractHandler(scope.row.id)" :disabled="scope.row.ok">通过</el-button>
          </template>
        </el-table-column> -->

      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2" />
      <!-- dialogWidth="1000px" -->

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler"
      :isShowArea="true" />
      <!-- @watchChange="watchChange"
      dialogWidth="1000px"
       -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" />
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
import { publicData2 } from '@/publicData/index'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'jzgd_yonggongbeian',
      dialogTitle: '劳动用工备案信息',
      // fileName: 'qiyexinxi',
      xlsCode: '56',
      importTipKey: 'idCard',
      importTiplabel: '证件号码',
      // filterForm: {
      //   contract: {}
      // }, // 特殊

      baseInfo: [
        { key: 'province', label: '省' },
        { key: 'city', label: '市' },
        { key: 'county', label: '县' },
        { key: 'town', label: '镇' },
        { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },

        { key: 'certType', label: '证件类型' },
        { key: 'idCard', label: '证件号码' },
        { key: 'name', label: '姓名' },
        { key: 'bornDate', label: '出生日期' },
        { key: 'sex', label: '性别' },
        { key: 'residenceType', label: '户口类型' },
        { key: 'nation', label: '民族' },
        { key: 'education', label: '文化程度' },
        { key: 'residenceAddress', label: '户籍地址' },
        { key: 'liveAddress', label: '现住地' },
        // { key: 'zipCode', label: '邮编' },
        // { key: 'startWorkYear', label: '开始工作年份' },
        // { key: 'country', label: '国藉' },
        // { key: 'insuranceId', label: '社保号' },
        // { key: 'o_name', label: '单位名称' },
        // { key: 'o_number', label: '到该单位工作次数' },
        // { key: 'jobType', label: '职工类别' },
        // { key: 'workType', label: '用工形式' },
        // { key: 'startDate', label: '用工开始时间' },
        // { key: 'hasContract', label: '是否已经签定了合同' },
        // { key: 'contractStatus', label: '合同状态' },
        // { key: 'continueContract', label: '合同续订次数' },
        // { key: 'contractPeriod', label: '合同期限' },
        // { key: 'contractStartDate', label: '合同期限起始日期' },
        // { key: 'probationStartDate', label: '试用期起始日期' },
        // { key: 'probationEndDate', label: '试用期终止日期' },
      ],
      // watchChangeKey: ['buyType'],
      // defaultKeyValue: {
      //   buyType: 1
      // },
      // userList: [],
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
    formItems() {
      return [
        // { type: 'text', key: 'o_name', label: '企业名称' },
        { type: 'select_s', key: 'certType', label: '证件类型', options: ['居民身份证','出生证','护照','警官证','执行公务证','学生证','毕业证','签证','结婚证','离婚证','独生子女证','学生证','驾驶证','计划生育证'] },
        { type: 'text', key: 'idCard', label: '证件号码' },
        { type: 'text', key: 'name', label: '姓名' },
        { type: 'text', key: 'bornDate', label: '出生日期', placeholder: '格式为yyyymmdd，6位数字' },
        { type: 'select_s', key: 'sex', label: '性别', options: ['男','女'] },
        { type: 'text', key: 'residenceType', label: '户口类型' },
        { type: 'select_s', key: 'nation', label: '民族', options: publicData2.nation },
        { type: 'text', key: 'education', label: '文化程度' },
        { type: 'text', key: 'residenceAddress', label: '户籍地址' },
        { type: 'text', key: 'liveAddress', label: '现住地' },
        { type: 'text', key: 'zipCode', label: '邮编' },
      ]
    },
    formItems2() {
      return [
        { type: 'text', key: 'startWorkYear', label: '开始工作年份', placeholder: '格式为yyyy，4位数字' },
        { type: 'text', key: 'country', label: '国藉' },
        { type: 'text', key: 'insuranceId', label: '社保号' },
        { type: 'text', key: 'o_name', label: '单位名称' },
        { type: 'text', key: 'o_number', label: '到该单位工作次数' },
        { type: 'text', key: 'jobType', label: '职工类别' },
        { type: 'text', key: 'workType', label: '用工形式' },
        { type: 'text', key: 'startDate', label: '用工开始时间', placeholder: '格式为yyyymmdd，6位数字' },
        { type: 'text', key: 'hasContract', label: '是否已经签定了合同', options: ['是','否'] },
        { type: 'text', key: 'contractStatus', label: '合同状态' },
        { type: 'text', key: 'continueContract', label: '合同续订次数' },
        { type: 'text', key: 'contractPeriod', label: '合同期限' },
        { type: 'text', key: 'contractStartDate', label: '合同期限起始日期', placeholder: '格式为yyyymmdd，6位数字' },
        { type: 'text', key: 'probationStartDate', label: '试用期起始日期', placeholder: '格式为yyyymmdd，6位数字' },
        { type: 'text', key: 'probationEndDate', label: '试用期终止日期', placeholder: '格式为yyyymmdd，6位数字' },
      ]
    }
  },
  methods: {
    // modifyHandlerBefore() {
    //   let {
    //     user
    //   } = this.selectData
    //   console.log(user.u_idCard)
    //   this.userList = [
    //     {
    //       label: user.u_idCard,
    //       value: user.id,
    //     }
    //   ]
    // },
    // watchChange(data) {
    //   console.log(`%caaaa:`, 'color: #f00;', data)
    //   switch (data.key) {
    //     case 'buyType':
    //       if (data.val === 1) {
    //         this.formItems.splice(8, 1)
    //       } else if (data.val === 2) {
    //         this.formItems.splice(8, 1, { type: 'text', key: 'cash', label: '垫付金额' })
    //       }
    //       break;
    //   }
    // },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        id, province, city, county, town, village, 
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        certType,
        idCard,
        name,
        bornDate,
        sex,
        residenceType,
        nation,
        education,
        residenceAddress,
        liveAddress,
        zipCode,
        startWorkYear,
        country,
        insuranceId,
        o_name,
        o_number,
        jobType,
        workType,
        startDate,
        hasContract,
        contractStatus,
        continueContract,
        contractPeriod,
        contractStartDate,
        probationStartDate,
        probationEndDate,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result

      const timeMap = {
        'bornDate': '出生日期',
        // 'incomeDstartWorkYearate': '开始工作年份',
        'startDate': '用工开始时间',
        'contractStartDate': '合同期限起始日期',
        'probationStartDate': '试用期起始日期',
        'probationEndDate': '试用期终止日期',
      }
      // let rD = JSON.parse(JSON.stringify(result))
      let rD = {}
      let dateDtatus = true
      let item = true
      Object.keys(timeMap).forEach(x => {
        if (dateDtatus) {
          if (result[x] && !/^[0-9]{8}$/.test(result[x])) {
            dateDtatus = false
            item = timeMap[x]
          }
        }
      })

      if (result.incomeDstartWorkYearate && !/^[0-9]{4}$/.test(result.incomeDstartWorkYearate)) {
        dateDtatus = false
        item = timeMap.incomeDstartWorkYearate
      }
      

// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (!certType) { this.$message.warning('请选择证件类型') }
      else if (!idCard) { this.$message.warning('请填写证件号码') }
      else if (!o_name) { this.$message.warning('请填写单位名称') }
      else if (!o_number) { this.$message.warning('请填写到该单位工作次数') }
      // else if (!driverType) { this.$message.warning('请选择出行方式') }
      else if (!dateDtatus) { this.$message.warning('请正确填写'+item+'的时间格式') }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      else if (this.isCreate) {
        rData = {
          province, city, county, town, village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          certType,
          idCard,
          name,
          bornDate,
          sex,
          residenceType,
          nation,
          education,
          residenceAddress,
          liveAddress,
          zipCode,
          startWorkYear,
          country,
          insuranceId,
          o_name,
          o_number,
          jobType,
          workType,
          startDate,
          hasContract,
          contractStatus,
          continueContract,
          contractPeriod,
          contractStartDate,
          probationStartDate,
          probationEndDate,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        // rData.catalog = this.catalog
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList_must = ['province', 'city', 'county', 'town', 'village']
        mapList_must.forEach(x => {
          rData[x] = result[x]
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList = [
          'certType',
          'idCard',
          'name',
          'bornDate',
          'sex',
          'residenceType',
          'nation',
          'education',
          'residenceAddress',
          'liveAddress',
          'zipCode',
          'startWorkYear',
          'country',
          'insuranceId',
          'o_name',
          'o_number',
          'jobType',
          'workType',
          'startDate',
          'hasContract',
          'contractStatus',
          'continueContract',
          'contractPeriod',
          'contractStartDate',
          'probationStartDate',
          'probationEndDate',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        // rData.userId = this.selectData.userId
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    // rD.catalog = this.catalog
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          this.tableData = _R
          // this.tableData = _R.map(x => {
          //   // x.areaName = x.province + x.city + x.county + x.town + x.village
          //   return x
          // })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    // getUesrData(val) {
    //   console.log(val, this.areaIds_x)
    //   let rD = {
    //     areaId: this.areaIds_x[this.areaIds_x.length - 1],
    //     u_idCard: val,
    //     personal: true,
    //   }
    //   // console.log(rD)
    //   this.$api.getUserList(rD).then( res=> {
    //     if (res.data.status == 0) {
    //       let _R = JSON.parse(res.data.data)
    //       this.userList = _R.map(x => {
    //         return {
    //           label: x.u_idCard,
    //           value: x.id,
    //         }
    //       })

    //       // 如果对话框里有切换的项目，修改前要先切换到对应的项目
    //       if(this.watchChangeKey) {
    //         let eData = this.$refs.DialogEdit.eData
    //         console.log(`%ceData:`, 'color: #f00;', eData)
    //         this.watchChangeKey.forEach(x => {
    //           this.watchChange({ key: x, val: eData[x] })
    //         })
    //       }
    //       console.log(`%c用户数据:`, 'color: #00f;', this.userList)
    //     } else { this._status(res.data) }
    //   })
    // },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // const powerStr = powerMap[this.catalog]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    this.btnShow.search = true
    // const mapList = ['search','create','modify','delete','import','export']
    const mapList = ['create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>